import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-style6',
  templateUrl: './card-style6.component.html',
  styleUrls: ['./card-style6.component.css']
})
export class CardStyle6Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
